import React, { useEffect, useState, useRef } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
const supportLinks = [{
  name: 'How to Order',
  href: '#/how-to-order'
}, {
  name: 'Wholesale Information',
  href: '#/wholesale'
}, {
  name: 'Shipping Information',
  href: '#/shipping'
}, {
  name: 'Returns & Exchanges',
  href: '#/returns'
}, {
  name: 'Privacy Policy',
  href: '#/privacy'
}, {
  name: 'Mailing List',
  href: '#/mailing-list'
}];
const mainLinks = [{
  name: 'Home',
  href: '#/'
}, {
  name: 'Switchplates',
  href: '#/switchplates'
}, {
  name: 'Size Chart',
  href: '#/size-chart'
}, {
  name: 'Custom Orders',
  href: '#/custom-orders'
}, {
  name: 'Support',
  href: '#/support',
  dropdown: supportLinks
}, {
  name: 'Reviews',
  href: '#/reviews'
}, {
  name: 'About',
  href: '#/about'
}, {
  name: 'Contact',
  href: '#/contact'
}];
export function Navigation() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [supportOpen, setSupportOpen] = useState(false);
  const [mobileSupportOpen, setMobileSupportOpen] = useState(false);
  const dropdownRef = useRef<HTMLLIElement>(null);
  // Close desktop dropdown on outside click
  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setSupportOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);
  return <nav className="bg-charcoal text-cream border-b border-charcoal-light relative z-30" data-id="element-730">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-731">
        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center justify-between py-3" data-id="element-732">
          <span className="text-sm font-bold tracking-wider uppercase text-gold" data-id="element-733">
            Menu
          </span>
          <button onClick={() => setMobileOpen(!mobileOpen)} className="text-cream hover:text-gold transition-colors p-1" aria-label="Toggle menu" data-id="element-734">
            {mobileOpen ? <X size={24} data-id="element-735" /> : <Menu size={24} data-id="element-736" />}
          </button>
        </div>

        {/* Desktop Navigation */}
        <ul className="hidden md:flex flex-wrap items-center justify-center lg:justify-start space-x-2 lg:space-x-8 py-3" data-id="element-737">
          {mainLinks.map(link => link.dropdown ? <li key={link.name} ref={dropdownRef} className="relative" onMouseEnter={() => setSupportOpen(true)} onMouseLeave={() => setSupportOpen(false)} data-id="element-738">
                <a href={link.href} className="flex items-center gap-1 px-3 py-2 text-sm font-medium tracking-wide hover:text-gold transition-colors relative group" data-id="element-739">
                  {link.name}
                  <ChevronDown size={14} className={`transition-transform ${supportOpen ? 'rotate-180' : ''}`} data-id="element-740" />
                  <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gold transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left" data-id="element-741" />
                </a>

                {supportOpen && <div className="absolute top-full left-0 pt-1 w-56" data-id="element-742">
                    <div className="bg-charcoal border border-charcoal-light rounded-sm shadow-xl overflow-hidden" data-id="element-743">
                      <ul className="py-1" data-id="element-744">
                        {link.dropdown.map(sub => <li key={sub.name} data-id="element-745">
                            <a href={sub.href} className="block px-5 py-2.5 text-sm text-cream hover:text-gold hover:bg-charcoal-light transition-colors" data-id="element-746">
                              {sub.name}
                            </a>
                          </li>)}
                      </ul>
                    </div>
                  </div>}
              </li> : <li key={link.name} data-id="element-747">
                <a href={link.href} className="block px-3 py-2 text-sm font-medium tracking-wide hover:text-gold transition-colors relative group" data-id="element-748">
                  {link.name}
                  <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gold transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left" data-id="element-749" />
                </a>
              </li>)}
        </ul>
      </div>

      {/* Mobile Dropdown */}
      {mobileOpen && <div className="md:hidden absolute top-full left-0 w-full bg-charcoal border-t border-charcoal-light shadow-xl" data-id="element-750">
          <ul className="flex flex-col py-2" data-id="element-751">
            {mainLinks.map(link => link.dropdown ? <li key={link.name} data-id="element-752">
                  <button onClick={() => setMobileSupportOpen(!mobileSupportOpen)} className="w-full flex items-center justify-between px-6 py-3 text-base font-medium text-cream hover:text-gold hover:bg-charcoal-light transition-colors border-b border-charcoal-light/50" data-id="element-753">
                    {link.name}
                    <ChevronDown size={16} className={`transition-transform ${mobileSupportOpen ? 'rotate-180' : ''}`} data-id="element-754" />
                  </button>
                  {mobileSupportOpen && <ul className="bg-charcoal-light/30" data-id="element-755">
                      {link.dropdown.map(sub => <li key={sub.name} data-id="element-756">
                          <a href={sub.href} onClick={() => {
                setMobileOpen(false);
                setMobileSupportOpen(false);
              }} className="block pl-10 pr-6 py-2.5 text-sm text-cream/80 hover:text-gold transition-colors border-b border-charcoal-light/30 last:border-0" data-id="element-757">
                            {sub.name}
                          </a>
                        </li>)}
                    </ul>}
                </li> : <li key={link.name} data-id="element-758">
                  <a href={link.href} onClick={() => setMobileOpen(false)} className="block px-6 py-3 text-base font-medium text-cream hover:text-gold hover:bg-charcoal-light transition-colors border-b border-charcoal-light/50 last:border-0" data-id="element-759">
                    {link.name}
                  </a>
                </li>)}
          </ul>
        </div>}
    </nav>;
}